<template>
<v-card>
  <v-card-title class="secondary white--text">
    Register Business Account
    <v-spacer></v-spacer>
    <v-btn dark icon @click="$emit('close')">
      <v-icon>fa-times</v-icon>
    </v-btn>
  </v-card-title>
  <v-container class="pt-6">
    <v-form ref="business-register-form" lazy-validation v-on:keyup.enter="registerAccount">
      <v-row justify="center">
        <v-col cols="10" md="10" class="py-0">
          <v-text-field outlined v-model="account.business" label="Business" clearable :rules="[rules.required]" :validate-on-blur="true"></v-text-field>
        </v-col>
        <v-col cols="10" md="10" class="py-0">
          <v-text-field outlined v-model="account.name" label="Main Contact" clearable :rules="[rules.required]" :validate-on-blur="true"></v-text-field>
        </v-col>
        <v-col cols="10" md="10" class="py-0">
          <v-text-field outlined v-model="account.email" label="Email" clearable :rules="[rules.required,rules.email]" :validate-on-blur="true"></v-text-field>
        </v-col>
        <v-col cols="10" md="10" class="py-0">
          <v-text-field outlined v-model="account.phone" v-on:keyup.enter="registerAccount" label="Phone Number" type="tel" masked="false" v-mask="'+1 (###) ###-####'" :rules="[rules.required,rules.phone]" :validate-on-blur="true" clearable persistent-hint></v-text-field>
        </v-col>
        <v-col cols="12" md="10" class="py-0 text-center" v-if="error">
          <v-alert type="error">
            {{error}}
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
  <v-card-actions class="grey lighten-3">
    <v-spacer></v-spacer>
    <v-btn text @click="clear">Clear</v-btn>
    <v-btn color="primary" dark @click="registerAccount" :loading="loading">Register</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import {
  mask
} from 'vue-the-mask'



export default {
  directives: {
    mask,
  },
  name: "",
  data: () => ({
    loading: false,
    error: '',
    account: {
      email: '',
      business: '',
      name: '',
      phone: '+1 '
    }
  }),
  computed: {
    rules() {
      return this.$helpers.rules
    }
  },
  methods: {
    async registerAccount() {
      if (!this.$refs['business-register-form'].validate()) {
        return;
      }
      this.loading = true;
      try {
        console.log("this.account", this.account)
        await this.$api({
          method: "POST",
          url: `/account/admin/accounts/register-business`,
          data: this.account
        })
        this.$emit('registered')
        this.$emit('close')
        this.$refs['business-register-form'].reset()
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false
    },
    clear() {
      this.$refs['business-register-form'].reset()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
